import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Home.css';

const Home = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="home-page section" id="home">
      <div className="container">
        <motion.div 
          className="home__content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <div className="home__text">
            <motion.div className="home__greeting" variants={itemVariants}>
              <span className="home__greeting-text">Hello! 👋</span>
              <span className="home__greeting-alt">Akwaaba</span>
            </motion.div>
            <motion.h1 className="home__title" variants={itemVariants}>
              I'm <span className="home__name">abdul-latif sadiq</span>
            </motion.h1>
            <motion.h2 className="home__subtitle" variants={itemVariants}>
              Software Engineer & Problem Solver
            </motion.h2>
            <motion.p className="home__description" variants={itemVariants}>
              I build digital experiences that matter. Currently crafting scalable solutions 
              and helping teams ship better products faster.
            </motion.p>
            <motion.p className="home__intro" variants={itemVariants}>
              Learn more <Link to="/about" className="home__link">about me</Link> 🙈 and discover the <Link to="/projects" className="home__link">projects I've built</Link> 🎢. Connect with me on my socials to stay updated on my journey.
            </motion.p>
          </div>

          <motion.div className="home__visual" variants={itemVariants}>
          <div className="home__code-showcase">
            <div className="code-window">
              <div className="code-header">
                <div className="code-dots">
                  <span className="dot dot--red"></span>
                  <span className="dot dot--yellow"></span>
                  <span className="dot dot--green"></span>
                </div>
                <div className="code-title">portfolio.py</div>
              </div>
              <div className="code-content">
                <div className="code-line">
                  <span className="code-variable">developer</span> = &#123;
                </div>
                <div className="code-line code-indent">
                  <span className="code-string">'name'</span>: <span className="code-string">'abdul-latif sadiq'</span>,
                </div>
                <div className="code-line code-indent">
                  <span className="code-string">'passion'</span>: <span className="code-string">'Clean Code'</span>,
                </div>
                <div className="code-line code-indent">
                  <span className="code-string">'focus'</span>: <span className="code-string">'Innovation'</span>
                </div>
                <div className="code-line">&#125;
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
      </div>
    </section>
  );
};

export default Home;